/**
 * Replace placeholders in a template string with provided values.
 * @param template The template string containing placeholders (e.g., {startFrom}).
 * @param replacements A map of placeholder keys and their replacement values.
 * @returns The processed string with placeholders replaced.
 */
export function replacePlaceholders(
  template: string,
  replacements: Record<string, string>
): string {
  return template.replaceAll(/\{(\w+)}/g, (match, key) => {
    return key in replacements ? replacements[key] : match; // Replace only if the key exists
  });
}
